import Fuse from "fuse.js";
import type { Sop } from "./types";

// Fuse rebuilds when the entry array reference changes. Cheap enough for
// our scale (a few hundred SOPs at most), so we don't memoize.

export function searchEntries(arr: Sop[], query: string, max = 20): Sop[] {
  const q = query.trim();
  if (!q) return [];
  const fuse = new Fuse(arr, {
    keys: [
      { name: "title", weight: 3 },
      { name: "description", weight: 2 },
      { name: "tags", weight: 2 },
      { name: "category", weight: 1 },
      { name: "body", weight: 0.5 },
    ],
    threshold: 0.35,
    ignoreLocation: true,
    includeScore: true,
    minMatchCharLength: 2,
  });
  return fuse
    .search(q)
    .slice(0, max)
    .map((r) => r.item);
}
